'use es6';

import { UPDATE_RECAPTCHA_TOKEN, UPDATE_RECAPTCHA_WIDGET_ID } from './ActionTypes';
import { getRecaptchaWidgetId } from '../../selectors/RecaptchaSelectors';
import { bookMeeting } from './BookActions';

var getRecaptchaNamespace = function getRecaptchaNamespace() {
  return window.grecaptcha.enterprise;
};

var updateToken = function updateToken(payload) {
  return {
    type: UPDATE_RECAPTCHA_TOKEN,
    payload: payload
  };
};

var resetToken = function resetToken() {
  return {
    type: UPDATE_RECAPTCHA_TOKEN,
    payload: null
  };
};

export var updateWidgetId = function updateWidgetId(payload) {
  return {
    type: UPDATE_RECAPTCHA_WIDGET_ID,
    payload: payload
  };
};
export var invokeChallenge = function invokeChallenge() {
  return function (dispatch, getState) {
    if (window.grecaptcha) {
      getRecaptchaNamespace().execute(getRecaptchaWidgetId(getState()));
    }
  };
};
export var handleChallengeSuccess = function handleChallengeSuccess(response) {
  return function (dispatch) {
    dispatch(updateToken(response));
    dispatch(bookMeeting());
  };
};
export var handleRecaptchaExpired = function handleRecaptchaExpired() {
  return function (dispatch, getState) {
    var widgetId = getRecaptchaWidgetId(getState());
    dispatch(resetToken());

    if (window.grecaptcha) {
      getRecaptchaNamespace().reset(widgetId);
    }
  };
};